import { BoxProps } from '@mui/system';
import React from 'react';
import Button, { Props } from './button';
import { ModalBackInStock } from './ModalBackInStock';
import { Product } from './GlobalState';
import { fbqReportConversion } from './hp-udl/UDLProvider';

export type AddToCartButtonProps = Partial<Props> & {
  addToCartAction?: () => void;
  variant?: 'primary' | 'ghost' | 'outline';
  color?: 'marigold' | 'white' | 'cyan';
  textSx?: BoxProps['sx']; // Style overrides for the button text Box.
  product: Product;
  text?: string;
};

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  addToCartAction,
  product,
  variant,
  sx,
  textSx,
  color,
  text,
  ...props
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const inStock = product?.stock > 0 ?? false;

  return (
    <>
      {product && (
        <ModalBackInStock
          productID={product.id}
          productName={product.name}
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
        />
      )}
      {inStock ? (
        <Button
          onClick={() => {
            fbqReportConversion('AddToCart');
            if (addToCartAction) {
              addToCartAction();
            }
          }}
          text={text ?? 'Add to Cart'}
          variant={variant ?? 'primary'}
          color={color}
          sx={sx}
          textSx={textSx}
          {...props}
        />
      ) : (
        <Button
          onClick={() => setShowModal(!showModal)}
          text="Notify Me"
          variant={variant ?? 'primary'}
          sx={sx}
          color={color}
          textSx={textSx}
          {...props}
        />
      )}
    </>
  );
};

export default AddToCartButton;
